import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase/firebaseConfig';

const PROFILE_BOOTSTRAP_TTL_MS = 30_000;
const cache = new Map();

/**
 * Shared decks + achievements + track_progress for profile page (one scan per visit).
 * @param {string} userId
 * @param {{ includeAchievements?: boolean }} [options]
 */
export async function fetchProfileBootstrap(userId, options = {}) {
  const { includeAchievements = true } = options;
  const uid = typeof userId === 'string' ? userId.trim() : '';
  if (!uid) {
    return { decksSnap: null, achievementsSnap: null, trackProgressSnap: null };
  }

  const cacheKey = `${uid}:${includeAchievements ? 'full' : 'core'}`;
  const cached = cache.get(cacheKey);
  if (cached && Date.now() - cached.at < PROFILE_BOOTSTRAP_TTL_MS) {
    return cached.value;
  }

  const [decksSnap, achievementsSnap, trackProgressSnap] = await Promise.all([
    getDocs(collection(db, `users/${uid}/decks`)),
    includeAchievements ? getDocs(collection(db, `users/${uid}/achievements`)) : Promise.resolve(null),
    getDocs(collection(db, `users/${uid}/track_progress`))
  ]);

  const value = { decksSnap, achievementsSnap, trackProgressSnap };
  cache.set(cacheKey, { at: Date.now(), value });
  return value;
}

export function invalidateProfileBootstrap(userId) {
  if (!userId) return;
  cache.delete(`${userId}:full`);
  cache.delete(`${userId}:core`);
}
